import React from 'react';

// import services data
import { services } from '../data';
import './Services.css'
export default function Services(){
  return (   
    <section  id='services'  class="pt-20 lg:pt-[120px] pb-12 lg:pb-[90px]">
       <div  class="container">
          <div class="flex flex-wrap -mx-4">
             <div class="w-full px-4">
                <div class="text-center mx-auto mb-12 lg:mb-20 max-w-[510px]">
                   <h2
                      class="
                      font-bold
                      text-3xl
                      sm:text-4xl
                      md:text-[40px]
                      text-dark
                      mb-4
                      "
                      >
                      Nuestros Servicios.
                   </h2>
                   
                </div>
             </div>
          </div>
          <div class="flex flex-wrap -mx-4">
             <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div
                   class="
                   p-10
                   md:px-7
                   xl:px-10
                   rounded-[20px]
                   bg-white
                   shadow-md
                   hover:shadow-lg
                   mb-8
                   "
                   >
                   <div
                      class="
                      w-[70px]
                      h-[70px]
                      flex
                      items-center
                      justify-center
                      bg-primary
                      rounded-2xl
                      mb-8
                      "
                      >
                     <svg
                     xmlns="http://www.w3.org/2000/svg"
                     x="0"
                     y="0"
                     height="32"
                     width="32"
                     enableBackground="new 0 0 458.317 458.317"
                     version="1.1"
                     viewBox="0 0 458.317 458.317"
                     xmlSpace="preserve"
                     >
                     <path d="M446.185 179.159h-64.768a159.359 159.359 0 00-9.26-22.29l45.818-45.818c4.737-4.737 4.737-12.416 0-17.152L364.416 40.34c-4.737-4.737-12.416-4.737-17.152 0l-45.818 45.818a159.347 159.347 0 00-22.289-9.26V12.131c.001-6.699-5.429-12.129-12.128-12.129h-75.743c-6.698 0-12.129 5.43-12.129 12.128v64.768a159.289 159.289 0 00-22.29 9.26L111.05 40.341c-4.737-4.737-12.416-4.737-17.152 0L40.339 93.9c-4.737 4.736-4.737 12.416 0 17.152l45.817 45.817a159.239 159.239 0 00-9.26 22.29H12.129C5.43 179.159 0 184.59 0 191.288v75.743c0 6.698 5.43 12.128 12.129 12.128h64.768a159.409 159.409 0 009.26 22.29L40.34 347.266c-4.737 4.736-4.737 12.416 0 17.152l53.559 53.559c4.737 4.736 12.416 4.736 17.152 0l45.817-45.817a159.189 159.189 0 0022.29 9.26v64.768c0 6.698 5.43 12.128 12.129 12.128h75.743c6.698 0 12.129-5.43 12.129-12.128V381.42a159.226 159.226 0 0022.289-9.26l45.818 45.817c4.737 4.736 12.416 4.736 17.152 0l53.559-53.559c4.737-4.737 4.737-12.416 0-17.152l-45.817-45.817a159.347 159.347 0 009.26-22.289h64.768c6.698 0 12.129-5.43 12.129-12.128v-75.743c-.003-6.699-5.433-12.13-12.132-12.13zM229.157 289.542c-33.349 0-60.384-27.035-60.384-60.384s27.035-60.384 60.384-60.384 60.384 27.035 60.384 60.384-27.035 60.384-60.384 60.384z "fill="white"></path>
                     </svg>
                      </div>
                     <h4 class="font-semibold text-xl text-dark mb-3">
                         Búsqueda activa de fugas.
                     </h4>
                     <p class="text-body-color">
                        Búsqueda de fugas con equipos modernos de detección electroacústica y correlación de alta calidad.                                
                     <br></br>
                     EQUIPOS SEWERIN SECORRPHONE AC 200.
                </p>
                </div>
             </div>
             <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div
                   class="
                   p-10
                   md:px-7
                   xl:px-10
                   rounded-[20px]
                   bg-white
                   shadow-md
                   hover:shadow-lg
                   mb-8
                   "
                   >
                   <div
                      class="
                      w-[70px]
                      h-[70px]
                      flex
                      items-center
                      justify-center
                      bg-primary
                      rounded-2xl
                      mb-8
                      "
                      >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30" 
                        viewBox="0 0 482.568 482.568"
                        fill="none"                    
                           >
                     <path d="M116.993 203.218c13.4-1.8 26.8 2.8 36.3 12.3l24 24 22.7-22.6-32.8-32.7c-5.1-5.1-5.1-13.4 0-18.5s13.4-5.1 18.5 0l32.8 32.8 22.7-22.6-24.1-24.1c-9.5-9.5-14.1-23-12.3-36.3 4-30.4-5.7-62.2-29-85.6-23.8-23.8-56.4-33.4-87.3-28.8-4.9.7-6.9 6.8-3.4 10.3l30.9 30.9c14.7 14.7 14.7 38.5 0 53.1l-19 19c-14.7 14.7-38.5 14.7-53.1 0l-31-30.9c-3.5-3.5-9.5-1.5-10.3 3.4-4.6 30.9 5 63.5 28.8 87.3 23.4 23.3 55.2 33 85.6 29zM309.193 243.918l-22.7 22.6 134.8 134.8c5.1 5.1 5.1 13.4 0 18.5s-13.4 5.1-18.5 0l-134.8-134.8-22.7 22.6 138.9 138.9c17.6 17.6 46.1 17.5 63.7-.1s17.6-46.1.1-63.7l-138.8-138.8z" fill="white"></path>
                     <path d="M361.293 153.918h59.9l59.9-119.7-29.9-29.9-119.8 59.8v59.9l-162.8 162.3-29.3-29.2-118 118c-24.6 24.6-24.6 64.4 0 89s64.4 24.6 89 0l118-118-29.9-29.9 162.9-162.3z"
                        fill="white"></path>
                     </svg>
                   </div>
                   <h4 class="font-semibold text-xl text-dark mb-3">
                      Consultoría para servicios de agua.
                  </h4>
                   <p class="text-body-color">
                   Acompañamiento para el mantenimiento adecuado de infraestructuras hidráulicas, plantas de tratamiento o redes de acueducto y alcantarillado.
                   </p>
                </div>
             </div>
             <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div
                   class="
                   p-10
                   md:px-7
                   xl:px-10
                   rounded-[20px]
                   bg-white
                   shadow-md
                   hover:shadow-lg
                   mb-8
                   "
                   >
                   <div
                      class="
                      w-[70px]
                      h-[70px]
                      flex
                      items-center
                      justify-center
                      bg-primary
                      rounded-2xl
                      mb-8
                      "
                      >
                      <svg
                         width="35"
                         height="35"
                         viewBox="0 0 35 35"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                         >
                         <path
                            d="M10.7734 14.3281H3.82813C2.07813 14.3281 0.65625 12.9062 0.65625 11.1562V4.21094C0.65625 2.46094 2.07813 1.03906 3.82813 1.03906H10.7734C12.5234 1.03906 13.9453 2.46094 13.9453 4.21094V11.1562C13.9453 12.9062 12.5234 14.3281 10.7734 14.3281ZM3.82813 2.95312C3.17188 2.95312 2.57031 3.5 2.57031 4.21094V11.1562C2.57031 11.8125 3.11719 12.4141 3.82813 12.4141H10.7734C11.4297 12.4141 12.0313 11.8672 12.0313 11.1562V4.21094C12.0313 3.55469 11.4844 2.95312 10.7734 2.95312H3.82813Z"
                            fill="white"
                            />
                         <path
                            d="M31.1719 14.3281H24.2266C22.4766 14.3281 21.0547 12.9062 21.0547 11.1562V4.21094C21.0547 2.46094 22.4766 1.03906 24.2266 1.03906H31.1719C32.9219 1.03906 34.3438 2.46094 34.3438 4.21094V11.1562C34.3438 12.9062 32.9219 14.3281 31.1719 14.3281ZM24.2266 2.95312C23.5703 2.95312 22.9688 3.5 22.9688 4.21094V11.1562C22.9688 11.8125 23.5156 12.4141 24.2266 12.4141H31.1719C31.8281 12.4141 32.4297 11.8672 32.4297 11.1562V4.21094C32.4297 3.55469 31.8828 2.95312 31.1719 2.95312H24.2266Z"
                            fill="white"
                            />
                         <path
                            d="M10.7734 33.9609H3.82813C2.07813 33.9609 0.65625 32.5391 0.65625 30.7891V23.8438C0.65625 22.0938 2.07813 20.6719 3.82813 20.6719H10.7734C12.5234 20.6719 13.9453 22.0938 13.9453 23.8438V30.7891C13.9453 32.5391 12.5234 33.9609 10.7734 33.9609ZM3.82813 22.5859C3.17188 22.5859 2.57031 23.1328 2.57031 23.8438V30.7891C2.57031 31.4453 3.11719 32.0469 3.82813 32.0469H10.7734C11.4297 32.0469 12.0313 31.5 12.0313 30.7891V23.8438C12.0313 23.1875 11.4844 22.5859 10.7734 22.5859H3.82813Z"
                            fill="white"
                            />
                         <path
                            d="M31.1719 33.9609H24.2266C22.4766 33.9609 21.0547 32.5391 21.0547 30.7891V23.8438C21.0547 22.0938 22.4766 20.6719 24.2266 20.6719H31.1719C32.9219 20.6719 34.3438 22.0938 34.3438 23.8438V30.7891C34.3438 32.5391 32.9219 33.9609 31.1719 33.9609ZM24.2266 22.5859C23.5703 22.5859 22.9688 23.1328 22.9688 23.8438V30.7891C22.9688 31.4453 23.5156 32.0469 24.2266 32.0469H31.1719C31.8281 32.0469 32.4297 31.5 32.4297 30.7891V23.8438C32.4297 23.1875 31.8828 22.5859 31.1719 22.5859H24.2266Z"
                            fill="white"
                            />
                      </svg>
                   </div>
                   <h4 class="font-semibold text-xl text-dark mb-3">
                      Sectorización de redes de abastecimiento.
                   </h4>
                   <p class="text-body-color">
                   Sectorización con SCADA y Telecontrol.
                   </p>
                </div>
             </div>
             <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div
                   class="
                   p-10
                   md:px-7
                   xl:px-10
                   rounded-[20px]
                   bg-white
                   shadow-md
                   hover:shadow-lg
                   mb-8
                   "
                   >
                   <div
                      class="
                      w-[70px]
                      h-[70px]
                      flex
                      items-center
                      justify-center
                      bg-primary
                      rounded-2xl
                      mb-8
                      "
                      >
                      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="38"
        version="1"
        viewBox="0 0 512 512"
      >
        <path
          d="M2269 5107c-25-19-36-47-49-117-6-36-15-89-21-117l-10-53h-53c-28 0-57-5-64-12-17-17-17-1249 0-1266 7-7 39-12 75-12h63v-264l-555-1392c-305-765-555-1398-555-1407 0-22 26-40 48-33 12 4 30 30 44 64 14 31 262 654 553 1385l529 1327h126V415l66-197c36-108 71-202 79-208s23-9 34-5c15 5 35 52 90 218l71 212v2776l61-3 62-3 546-1373c301-755 555-1380 564-1390 26-25 52-4 51 39-1 19-248 653-548 1409l-546 1374v266h56c104 0 94-67 94 643 0 471-3 626-12 635-7 7-36 12-64 12h-53l-10 53c-6 28-15 81-21 117-13 70-24 98-49 117-12 9-92 12-301 12s-289-3-301-12zm576-159c9-51 19-101 22-110 4-17-15-18-297-18s-301 1-296 18c3 9 12 59 21 110l17 92h516l17-92zm155-773v-565h-860v1130h860v-565zm-150-765v-120h-560v240h560v-120zm-190-575v-375h-180v750h180v-375zm0-1410V470h-180v1910h180v-955zm-20-1038c0-4-58-177-66-197-5-13-74 166-74 192 0 4 32 8 70 8 39 0 70-1 70-3z"
          transform="matrix(.1 0 0 -.1 0 512)"fill='white'
        ></path>
        <path
          d="M2517 4615c-65-17-114-65-133-132-14-48-14-58 0-106 39-133 202-185 308-97 46 38 68 86 68 149 0 133-115 220-243 186zm113-92c33-19 50-51 50-94 0-66-43-108-111-109-56 0-94 26-108 74-12 47-3 82 31 116 35 35 92 41 138 13zM2840 4265c-14-17-5-51 16-59 20-8 54 11 54 29 0 43-43 62-70 30zM2256 4064c-13-13-16-42-16-160 0-81 5-154 10-165 10-18 24-19 315-19 263 0 306 2 319 16 23 23 23 305 0 328-13 14-56 16-314 16s-301-2-314-16zm562-166l3-98h-501v200l248-2 247-3 3-97zM1904 3976c-3-7-4-41-2-76 3-70 22-95 56-74 21 14 30 127 11 150-15 18-58 18-65 0zM3172 3818c-7-7-12-40-12-80 0-57 3-69 20-78 34-18 60 19 60 84 0 71-34 108-68 74z"
          transform="matrix(.1 0 0 -.1 0 512)" fill='white'
        ></path>
      </svg>
                   </div>
                   <h4 class="font-semibold text-xl text-dark mb-3">
                      Topografía con RTK.
                   </h4>
                   <p class="text-body-color">
                      Con equipos RTK de alta tecnología describimos detalladamente la superficie de un terreno o área, los datos de las superficies se verán reflejados en planos.<br></br>Posicionamiento de puntos topográficos en tiempo real con equipos novedosos y actualizados RTK.
                    
                   </p>
                </div>
             </div>
             <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div
                   class="
                   p-10
                   md:px-7
                   xl:px-10
                   rounded-[20px]
                   bg-white
                   shadow-md
                   hover:shadow-lg
                   mb-8
                   "
                   >
                   <div
                      class="
                      w-[70px]
                      h-[70px]
                      flex
                      items-center
                      justify-center
                      bg-primary
                      rounded-2xl
                      mb-8
                      "
                      >
                      <svg
                         width="35"
                         height="35"
                         viewBox="0 0 35 35"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg"
                         >
                         <path
                            d="M29.5312 21.6562L28.6563 21.1641L29.6953 20.5625C30.7344 19.9062 31.3359 18.8125 31.2812 17.6094C31.2266 16.4063 30.625 15.3125 29.5312 14.7109L27.8906 13.7813L29.6406 12.6875C30.6797 12.0313 31.2812 10.9375 31.2266 9.73438C31.1719 8.53125 30.5703 7.4375 29.4766 6.83594L19.25 1.09375C18.2109 0.492187 16.9531 0.546875 15.9141 1.09375L5.41406 7.21875C4.375 7.82031 3.71875 8.91406 3.71875 10.1172C3.71875 11.3203 4.375 12.4141 5.41406 13.0156L7.10938 14L5.41406 14.9844C4.375 15.5859 3.71875 16.6797 3.71875 17.8828C3.71875 19.0859 4.32031 20.1797 5.41406 20.7812L6.39844 21.3281L5.46875 21.875C4.42969 22.4766 3.77344 23.5703 3.77344 24.7734C3.77344 25.9766 4.375 27.0703 5.46875 27.6719L15.9141 33.6875C16.4609 34.0156 17.0078 34.125 17.6094 34.125C18.2109 34.125 18.8125 33.9609 19.3594 33.6328L29.6953 27.2891C30.7344 26.6328 31.3359 25.5391 31.2812 24.3359C31.2266 23.2969 30.625 22.2031 29.5312 21.6562ZM5.63281 10.1172C5.63281 9.57031 5.90625 9.13281 6.34375 8.85938L16.8438 2.78906C17.0625 2.67969 17.3359 2.57031 17.5547 2.57031C17.7734 2.57031 18.0469 2.625 18.2656 2.73437L28.5469 8.47656C28.9844 8.75 29.2578 9.1875 29.3125 9.73438C29.3125 10.2812 29.0391 10.7188 28.6016 10.9922L18.3203 17.3906C17.8828 17.6641 17.2812 17.6641 16.8438 17.3906L6.39844 11.375C5.90625 11.1562 5.63281 10.6641 5.63281 10.1172ZM5.63281 17.9375C5.63281 17.3906 5.90625 16.9531 6.34375 16.6797L9.02344 15.1484L15.8594 19.0859C16.4062 19.4141 16.9531 19.5234 17.5547 19.5234C18.1562 19.5234 18.7578 19.3594 19.3047 19.0312L26.0312 14.875L28.6016 16.2969C29.0391 16.5703 29.3125 17.0078 29.3672 17.5547C29.3672 18.1016 29.0938 18.5391 28.6563 18.8125L18.3203 25.2656C17.8828 25.5391 17.2812 25.5391 16.8438 25.2656L6.39844 19.25C5.90625 18.9766 5.63281 18.4844 5.63281 17.9375ZM28.6563 25.8125L18.3203 32.2109C17.8828 32.4844 17.2812 32.4844 16.8438 32.2109L6.39844 26.1953C5.96094 25.9219 5.6875 25.4844 5.6875 24.9375C5.6875 24.3906 5.96094 23.9531 6.39844 23.6797L8.3125 22.5859L15.8594 26.9609C16.4062 27.2891 16.9531 27.3984 17.5547 27.3984C18.1562 27.3984 18.7578 27.2344 19.3047 26.9062L26.7969 22.2578L28.6563 23.2969C29.0938 23.5703 29.3672 24.0078 29.4219 24.5547C29.3672 25.0469 29.0938 25.5391 28.6563 25.8125Z"
                            fill="white"
                            />
                      </svg>
                   </div>
                   <h4 class="font-semibold text-xl text-dark mb-3">
                      Diseños hidraúlicos.
                   </h4>
                   <p class="text-body-color">
                 Diseño de red de acueducto.
                      <br></br>
                      Diseño de red de alcantarillado.
                      <br></br>
                 Diseño de sistemas de bombeo en redes de  acueducto.
                 <br></br>
                 Diseño de sistemas de bombeo en redes de alcantarillado .
                 <br></br>
                 Diseño estructural de obras.
                 <br></br>
                 Proyecciones de líneas de acueducto y alcantarillado.
                   </p>
                </div>
             </div>
             <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div
                   class="
                   p-10
                   md:px-7
                   xl:px-10
                   rounded-[20px]
                   bg-white
                   shadow-md
                   hover:shadow-lg
                   mb-8
                   "
                   >
                   <div
                      class="
                      w-[70px]
                      h-[70px]
                      flex
                      items-center
                      justify-center
                      bg-primary
                      rounded-2xl
                      mb-8
                      "
                      >
                     <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        version="1"
        viewBox="0 0 512 512"
      >
        <path
          d="M376 4959c-113-39-196-115-250-228l-31-66-3-1445c-2-962 1-1461 8-1493 25-120 124-243 233-291 51-23 54-27 81-95 65-166 205-309 394-405 117-59 282-76 412-41 180 47 310 160 429 373l75 132h148l-7-87c-15-196-67-450-117-565l-20-46-181-4c-174-3-184-5-233-30-65-34-118-96-140-161-21-63-15-157 14-212 24-47 83-105 132-131 34-18 84-19 1240-19s1206 1 1240 19c49 26 108 84 132 131 29 55 35 149 14 212-22 65-76 127-140 161-48 25-60 27-235 32l-184 5-27 72c-57 147-100 350-115 540l-7 83 743 2 744 3 58 27c115 54 211 174 237 295 7 32 10 544 8 1533l-3 1485-28 53c-35 67-89 121-152 152l-50 25-2180 2c-2171 2-2180 2-2239-18zm4412-140c26-13 54-38 70-62l27-41 3-1248 2-1248H3074c-998 0-1814 4-1812 8 2 5 52 92 111 194 128 222 137 253 92 343-36 75-85 108-169 113-69 4-121-15-163-60-12-12-96-151-187-308l-165-285-275-3-276-2v1188c0 1334-4 1255 73 1339 40 44 78 69 127 84 14 4 990 8 2169 8l2145 1 44-21zM1324 2725c37-37 33-46-163-385-105-181-193-340-196-353-4-15 1-32 15-50 31-39 72-36 121 8 46 41 62 43 94 10 28-27 30-42 14-79-16-35-3-73 31-91s64-9 99 29c29 31 71 34 95 7 15-17 17-30 11-80-6-52-4-62 14-80 31-31 68-26 112 14 22 19 46 35 54 35 21 0 65-45 65-66 0-31-223-415-273-470-92-102-209-154-346-154-105 0-188 27-281 91-157 107-209 178-293 404-25 66-55 142-66 168-28 66-27 112 4 142 37 38 72 33 134-20 57-49 78-54 109-27 11 9 139 222 283 472s268 463 277 473c19 21 65 22 86 2zm-661-707c-20-35-37-64-39-66-1-2-21 6-45 18-163 84-354-83-306-267 8-29 13-53 11-53s-14 19-26 43c-21 38-23 58-26 215l-4 172h471l-36-62zm4227-90c0-84-5-170-10-190-19-68-71-130-139-165l-63-33H3243c-1363 0-1435 1-1428 18 4 9 10 38 13 65 12 121-88 227-215 227-18 0-33 4-33 10 0 18-63 81-101 101-21 10-58 19-83 19-37 0-47 4-57 23-6 12-23 34-37 50l-26 27h3614v-152zm-1782-660c14-155 47-323 91-459 17-53 31-99 31-103 0-3-303-6-674-6h-674l25 73c50 146 85 336 99 530l7 97h1084l11-132zm632-726c88-44 106-151 36-220l-36-37-1163-3c-820-2-1170 1-1188 9-80 32-113 131-67 199 50 75-41 70 1238 70 1070 0 1147-1 1180-18z"
          transform="matrix(.1 0 0 -.1 0 512)" fill='white'
        ></path>
        <path
          d="M2516 4459l-26-20v-210c0-280-19-259 244-259 214 0 239 5 256 53 14 40 13 365-1 406-6 17-19 36-29 41-11 6-107 10-218 10-186 0-201-1-226-21zm334-234v-105h-220v210h220v-105zM3206 4459l-26-20v-428l26-20c25-20 40-21 224-21s199 1 224 21l26 20v214c0 279 23 255-246 255-189 0-203-1-228-21zm334-234v-115h-220v230h220v-115zM3896 4459l-26-20v-428l26-20c25-20 40-21 224-21s199 1 224 21l26 20v428l-26 20c-25 20-40 21-224 21s-199-1-224-21zm334-234v-115h-220v230h220v-115zM2510 3580c-29-29-26-74 6-99 27-21 31-21 918-21 884 0 892 0 914 20 28 26 29 73 2 100-20 20-33 20-920 20s-900 0-920-20zM1187 3544c-198-36-383-154-498-318-53-75-63-121-31-149 44-39 87-22 137 54 80 121 227 225 375 265 79 21 234 23 310 5 183-44 352-177 435-341 91-180 93-406 4-581-35-71-36-93-4-124 48-49 89-27 139 72 155 310 59 732-217 951-189 151-415 209-650 166z"
          transform="matrix(.1 0 0 -.1 0 512)" fill='white'
        ></path>
        <path
          d="M1250 3239c-113-20-234-94-300-187-45-62-51-101-20-132 33-33 75-26 107 17 46 61 92 102 147 131 46 24 62 27 151 27 92 0 104-2 153-30 71-38 136-112 162-183 29-75 25-196-8-259-12-23-22-54-22-68 0-50 61-81 109-55 27 14 69 118 82 201 12 87-3 184-45 275-29 62-122 165-182 200-95 56-228 81-334 63zM2516 3129c-32-25-35-70-6-99 20-20 33-20 923-20 863 0 905 1 920 18 26 29 22 77-9 101-27 21-31 21-914 21s-887 0-914-21zM2516 2659c-32-25-35-70-6-99 20-20 33-20 920-20s900 0 920 20c27 27 26 74-2 100-22 20-30 20-914 20-887 0-891 0-918-21zM2322 1857c-28-30-28-68 1-95 22-21 31-22 238-22 212 0 216 0 237 23 28 29 28 57 1 91l-20 26h-218c-214 0-218 0-239-23z"
          transform="matrix(.1 0 0 -.1 0 512)"
        ></path>
      </svg>
                   </div>
                   <h4 class="font-semibold text-xl text-dark mb-3">
                      Digitalización de redes y elementos en acueducto y alcantarillado.
                   </h4>
                   <p class="text-body-color">
                     La digitalización es fundamental para optimizar el sistema acueducto- alcantarillado, reduciendo costos, mejorando el rendimiento del ciclo del agua.<br></br>Formatos: Gis-Autocad-Dgn,o requerido.
                   </p>
                </div>
             </div>
             <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div
                   class="
                   p-10
                   md:px-7
                   xl:px-10
                   rounded-[20px]
                   bg-white
                   shadow-md
                   hover:shadow-lg
                   mb-8
                   "
                   >
                   <div
                      class="
                      w-[70px]
                      h-[70px]
                      flex
                      items-center
                      justify-center
                      bg-primary
                      rounded-2xl
                      mb-8
                      "
                      >
                            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            version="1"
         viewBox="0 0 512 512"
    >
      <path
        d="M278.5-.5h14c5.04 2.53 9.373 6.03 13 10.5 23.133 8.977 36.467 25.81 40 50.5 7.113 1.481 12.946 5.148 17.5 11a256.197 256.197 0 0012 25 64.218 64.218 0 010 16 256.141 256.141 0 00-12 25c-4.628 5.727-10.461 9.56-17.5 11.5-40 .667-80 .667-120 0-7.039-1.94-12.872-5.773-17.5-11.5a256.141 256.141 0 00-12-25 64.218 64.218 0 010-16 256.197 256.197 0 0012-25c4.554-5.852 10.387-9.519 17.5-11 3.504-24.666 16.837-41.499 40-50.5 3.263-4.948 7.597-8.448 13-10.5zm4 16c4.184-.796 7.35.537 9.5 4 .5 13.33.667 26.663.5 40h-14c-.167-13.337 0-26.67.5-40 .69-1.85 1.856-3.184 3.5-4zm-21 14c.994 9.82 1.327 19.82 1 30-7.008.166-14.008 0-21-.5 2.856-12.584 9.523-22.417 20-29.5zm47 0c11.26 6.647 18.26 16.48 21 29.5-6.992.5-13.992.666-21 .5v-30zm-75 45a8.435 8.435 0 014 .5c-8.915 21.758-5.581 41.425 10 59-7.995 1.217-15.661.217-23-3-3.866-3.252-6.033-7.419-6.5-12.5a41.056 41.056 0 01-6-9c-1.769-6.736-.102-12.402 5-17 1.279-10.104 6.779-16.104 16.5-18zm22 0c20.011-.333 40.011 0 60 1 11.045 18.664 8.712 35.497-7 50.5-15.333 10-30.667 10-46 0-15.773-15.328-18.106-32.494-7-51.5zm78 1c11.108-1.426 17.608 3.574 19.5 15a41.056 41.056 0 016 9c1.769 6.736.102 12.402-5 17-1.095 10.093-6.595 15.926-16.5 17.5a49.226 49.226 0 01-14 0c15.538-17.513 18.872-37.013 10-58.5z"
        opacity="0.947" fill='white'
      ></path>
      <path
        d="M349.5 511.5h-9a426.785 426.785 0 00-27-9.5c-2.439-.774-4.273-2.274-5.5-4.5a9517.45 9517.45 0 01-.5-138h-44c.167 46.001 0 92.001-.5 138a17.842 17.842 0 01-5.5 4.5 426.785 426.785 0 00-27 9.5h-9c-4.85-4.297-5.183-8.964-1-14a213.584 213.584 0 0127-9v-129c-8.673.166-17.34 0-26-.5l-3.5-3.5a7136.932 7136.932 0 010-169c2.317-10.983 8.817-18.149 19.5-21.5 32-.667 64-.667 96 0 9.241 2.907 15.574 8.907 19 18 35.088-4.079 58.755-22.746 71-56a113.626 113.626 0 004.5-28.5c4.954-5.324 9.954-5.324 15 0 .638 37.898-14.862 67.065-46.5 87.5-13.304 7.824-27.638 12.324-43 13.5.167 51.668 0 103.334-.5 155a11.532 11.532 0 01-3.5 4.5c-8.66.5-17.327.666-26 .5v129a213.584 213.584 0 0127 9c4.262 5.067 3.929 9.733-1 14zm-104-332c1.988 19.639 2.655 39.639 2 60h-14c-.167-16.67 0-33.337.5-50 1.75-5.784 5.584-9.117 11.5-10zm18 0h44v15c-5.067.189-9.734 1.689-14 4.5a84.853 84.853 0 01-8 7.5 120.678 120.678 0 00-10-8.5c-3.687-2.285-7.687-3.452-12-3.5v-15zm60 0c6.859.329 11.359 3.662 13.5 10 .5 16.663.667 33.33.5 50h-14v-60zm-60 31c6.362 3.85 12.029 8.684 17 14.5 3.333 2 6.667 2 10 0a109.399 109.399 0 0116-14.5 3876.599 3876.599 0 011.5 88c3.454 16.121 13.121 26.455 29 31 .499 4.989.666 9.989.5 15h-104a112.97 112.97 0 01.5-15c15.879-4.545 25.546-14.879 29-31 .5-29.331.667-58.665.5-88zm-30 44h14c.167 14.004 0 28.004-.5 42-1.972 7.29-6.305 12.623-13 16-.5-19.33-.667-38.664-.5-58zm90 0h14c.167 19.336 0 38.67-.5 58-6.891-3.227-11.224-8.56-13-16a881.746 881.746 0 01-.5-42z"
        opacity="0.945" fill='white'
      ></path>
      <path
        d="M101.5 164.5c22.669-.167 45.336 0 68 .5l3.5 3.5c.667 32 .667 64 0 96a11.532 11.532 0 01-3.5 4.5c-22.667.667-45.333.667-68 0l-3.5-3.5a2352.382 2352.382 0 010-97 20.67 20.67 0 013.5-4zm12 15h44v15h-44v-15zm0 30h44v45h-44v-45z"
        opacity="0.967" fill='white'
      ></path>
      <path
        d="M131.5 224.5c8.161-1.329 11.995 2.005 11.5 10-2.435 4.724-6.269 6.224-11.5 4.5-5.275-4.878-5.275-9.711 0-14.5z"
        opacity="0.878" fill='white'
      ></path>
      <path
        d="M199.5 511.5h-8a20.673 20.673 0 01-3.5-4 113636.455 113636.455 0 00-29.5-178h-15c.167 59.001 0 118.001-.5 177a27.241 27.241 0 01-3.5 5h-8a19.552 19.552 0 00-3.5-4c-.5-59.332-.667-118.666-.5-178h-15a49504.315 49504.315 0 01-29.5 178 19.555 19.555 0 00-3.5 4h-8c-2.39-1.902-3.723-4.402-4-7.5 9.78-59.842 19.612-119.675 29.5-179.5l1-36c.833-1.5 2-2.667 3.5-3.5 22.667-.667 45.333-.667 68 0l3.5 3.5 1 36c9.88 59.659 19.713 119.326 29.5 179-.3 3.266-1.633 5.933-4 8zm-86-212h44v15h-44v-15z"
        opacity="0.942" fill='white'
      ></path>
    </svg>
                   </div>
                   <h4 class="font-semibold text-xl text-dark mb-3">
                     Estudios geotécnicos y tomografías eléctricas.
                   </h4>
                   <p class="text-body-color">
                  Estudios de suelos, geológicos, geotécnicos, y de impacto ambiental.
                   <br></br>
                  Diseño de estructura de pavimentos rígido y flexible.
                  <br></br>
                  Estudios de vulnerabilidad y refracción sísmica.
                  <br></br>
                  Estudios de estabilidad de taludes.
                  <br></br>
                  Levantamiento topográfico.
                  </p>
                </div>
             </div>
             <div class="w-full md:w-1/2 lg:w-1/3 px-4">
                <div
                   class="
                   p-10
                   md:px-7
                   xl:px-10
                   rounded-[20px]
                   bg-white
                   shadow-md
                   hover:shadow-lg
                   mb-8
                   "
                   >
                   <div
                      class="
                      w-[70px]
                      h-[70px]
                      flex
                      items-center
                      justify-center
                      bg-primary
                      rounded-2xl
                      mb-8
                      "
                      >
                      <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill='none'
            ersion="1"
            viewBox="0 0 512 512"
         >
            <path
            d="M183.5-.5h144c28.465 6.964 46.632 24.63 54.5 53a4587.734 4587.734 0 011 190c-1.787 13.904-7.121 26.237-16 37l-43 43a4690.155 4690.155 0 000 137c.98 5.959 3.98 10.626 9 14 9.767 16.514 6.267 29.181-10.5 38h-134c-16.767-8.819-20.267-21.486-10.5-38 5.02-3.374 8.02-8.041 9-14l1-78c3.013-5.035 7.18-6.202 12.5-3.5a6.978 6.978 0 012.5 3.5 1599.45 1599.45 0 010 80c-.749 5-2.416 9.667-5 14l-9 11c-1.193 5.443.973 8.61 6.5 9.5 40 .667 80 .667 120 0 5.527-.89 7.693-4.057 6.5-9.5l-9-11a38.097 38.097 0 01-5-14 5253.873 5253.873 0 010-145 1527.19 1527.19 0 0146-47c5.835-6.669 9.835-14.335 12-23a4398.292 4398.292 0 001-186c-4.527-23.526-18.36-38.36-41.5-44.5a1336.679 1336.679 0 00-70-1.5c-23.356-.111-46.69.389-70 1.5-23.14 6.14-36.973 20.974-41.5 44.5l-1 48c-2.435 4.724-6.269 6.224-11.5 4.5a11.532 11.532 0 01-3.5-4.5 624.938 624.938 0 010-50c6.011-31.508 24.511-51.175 55.5-59zm55 393c11.338-.167 22.672 0 34 .5 6.667 4.333 6.667 8.667 0 13a289.106 289.106 0 01-34 0c-6.586-4.493-6.586-8.993 0-13.5zm0 60c11.338-.167 22.672 0 34 .5 6.667 4.333 6.667 8.667 0 13a289.106 289.106 0 01-34 0c-6.586-4.493-6.586-8.993 0-13.5z"
             fill='white'
            ></path>
            <path
            d="M186.5 29.5c46.001-.167 92.001 0 138 .5 15.714 4.38 25.214 14.547 28.5 30.5.667 60 .667 120 0 180-3.829 17.163-14.329 27.663-31.5 31.5-44 .667-88 .667-132 0-17.171-3.837-27.671-14.337-31.5-31.5-.667-60-.667-120 0-180 3.473-15.97 12.973-26.303 28.5-31zm9 15c40.001-.167 80.001 0 120 .5 11.314.74 18.48 6.573 21.5 17.5a7740.38 7740.38 0 010 176c-2.491 9.158-8.325 14.991-17.5 17.5-42.667.667-85.333.667-128 0-9.175-2.509-15.009-8.342-17.5-17.5a7740.38 7740.38 0 010-176c3.248-10.851 10.415-16.851 21.5-18zm8 30h104v92h-104v-92zm5 138c7.518.387 10.018 4.054 7.5 11-5.977 4.602-10.144 3.269-12.5-4 .56-3.212 2.227-5.545 5-7zm90 0c7.518.387 10.018 4.054 7.5 11-5.977 4.602-10.144 3.269-12.5-4 .56-3.212 2.227-5.545 5-7z"
             fill='white'
            ></path>
            <path
            d="M191.5 59.5c42.668-.167 85.335 0 128 .5l3.5 3.5c.988 38.751.654 77.418-1 116a6.978 6.978 0 01-3.5 2.5c-42.751.989-85.417.655-128-1a6.978 6.978 0 01-2.5-3.5c-.667-38-.667-76 0-114a20.682 20.682 0 013.5-4zm12 15v92h104v-92h-104z"
            fill='white'
            ></path>
            <path
            d="M133.5 127.5c4.294-.302 7.461 1.364 9.5 5l1 109c1.646 10.622 5.979 19.956 13 28a1527.19 1527.19 0 0146 47 420.29 420.29 0 010 41c-2.226 4.361-5.726 5.861-10.5 4.5-2.167-.833-3.667-2.333-4.5-4.5l-1-35a881.728 881.728 0 01-49-51c-5.527-8.915-8.861-18.582-10-29a3023.738 3023.738 0 010-110c1.107-2.613 2.94-4.28 5.5-5z"
            fill='white'
            ></path>
            <path
            d="M205.5 196.5c19.134-.367 28.3 8.966 27.5 28-5.96 16.108-17.127 21.275-33.5 15.5-11.421-7.934-14.588-18.434-9.5-31.5 3.644-6.165 8.811-10.165 15.5-12zm3 16c-2.773 1.455-4.44 3.788-5 7 2.356 7.269 6.523 8.602 12.5 4 2.518-6.946.018-10.613-7.5-11zM295.5 196.5c19.134-.367 28.3 8.966 27.5 28-5.96 16.108-17.127 21.275-33.5 15.5-11.421-7.934-14.588-18.434-9.5-31.5 3.644-6.165 8.811-10.165 15.5-12zm3 16c-2.773 1.455-4.44 3.788-5 7 2.356 7.269 6.523 8.602 12.5 4 2.518-6.946.018-10.613-7.5-11z"
             fill='white'
            ></path>
            <path
            d="M235.5 316.5c13.337-.167 26.671 0 40 .5 16.105 5.947 21.272 17.113 15.5 33.5-3.472 6.141-8.638 9.974-15.5 11.5a400.05 400.05 0 01-40 0c-13.28-4.387-19.113-13.553-17.5-27.5 2.692-9.191 8.525-15.191 17.5-18zm3 16c11.338-.167 22.672 0 34 .5 6.667 4.333 6.667 8.667 0 13a289.106 289.106 0 01-34 0c-6.586-4.493-6.586-8.993 0-13.5zM235.5 376.5c13.337-.167 26.671 0 40 .5 16.105 5.947 21.272 17.113 15.5 33.5-3.472 6.141-8.638 9.974-15.5 11.5a400.05 400.05 0 01-40 0c-13.28-4.387-19.113-13.553-17.5-27.5 2.692-9.191 8.525-15.191 17.5-18zm3 16c-6.586 4.507-6.586 9.007 0 13.5 11.333.667 22.667.667 34 0 6.667-4.333 6.667-8.667 0-13a577.896 577.896 0 00-34-.5zM235.5 436.5c13.337-.167 26.671 0 40 .5 16.105 5.947 21.272 17.113 15.5 33.5-3.472 6.141-8.638 9.974-15.5 11.5a400.05 400.05 0 01-40 0c-13.28-4.387-19.113-13.553-17.5-27.5 2.692-9.191 8.525-15.191 17.5-18zm3 16c-6.586 4.507-6.586 9.007 0 13.5 11.333.667 22.667.667 34 0 6.667-4.333 6.667-8.667 0-13a577.896 577.896 0 00-34-.5z"
            fill='white'
            ></path>
            </svg>
                   </div>
                   <h4 class="font-semibold text-xl text-dark mb-3">
                     Búsqueda de fugas interiores con cámara termográfica.
                   </h4>
                   <p class="text-body-color">
                     Cámara termográfica FLIR C5 con tecnología de imágenes térmicas precisas para detectar cambios en la temperatura de las superficies.<br></br> Capacidad de medición de húmedad, lo que permite la detección de la presencia de humedad en áreas inspeccionadas.
                   </p>
                </div>
             </div>
          </div>
          
       </div>
    </section>
    
  
  )
  }